import React from 'react';
import { Link } from 'react-router-dom';

import { Card, Col, Row, Space, Typography } from 'antd';

import { URL_SELECT } from 'settings';
import type { IUserData } from 'v2/interfaces/user';

import { WithQualificationValidation } from './withQualificationValidation';

export type QuickStartProps = {
  user: IUserData;
};

function QuickStart({ user }: QuickStartProps) {
  return (
    <div className='mx-auto w-[80vw] max-w-225 p-16 text-center'>
      <Space direction='vertical' size='middle'>
        <Typography.Title level={2}>Olá, {user.name}</Typography.Title>
        <Typography.Text>
          Agora que você é Parceiro Eduzz, está pronto para iniciar seu trabalho, seja como afiliado ou produtor de
          conteúdos digitais.Escolha abaixo por onde deseja começar.
        </Typography.Text>
      </Space>

      <Row gutter={[16, 16]} className='mt-4'>
        <Col md={12} xs={24}>
          <Link to={'/producer/product/newproduct'}>
            <Card hoverable className='h-full min-h-37.5'>
              <Typography.Title level={4}>Cadastre seu produto</Typography.Title>
              <Typography.Text>
                Venda cursos online,e-books, softwares, ingressos para eventos, musicas ou qualquer outro tipo de
                produto digital.
              </Typography.Text>
            </Card>
          </Link>
        </Col>
        <Col md={12} xs={24}>
          <a href={URL_SELECT}>
            <Card hoverable className='h-full min-h-37.5'>
              <Typography.Title level={4}>Afilie-se a um produto</Typography.Title>
              <Typography.Text>
                Entre em nossa vitrine, escolha um produto para se afiliar e promova-o em troca de comissões por cada
                venda
              </Typography.Text>
            </Card>
          </a>
        </Col>
        <Col md={12} xs={24}>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={'https://academia360.eduzz.com/cursos?utm_source=orbita&utm_medium=quickstart'}
          >
            <Card hoverable className='h-full min-h-37.5'>
              <Typography.Title level={4}>Primeiros passos no Marketing Digital</Typography.Title>
              <Typography.Text>
                Aprenda a melhor forma de se tornar um empreendedor digital e fazer vendas com os cursos gratuitos da
                Academia 360.
              </Typography.Text>
            </Card>
          </a>
        </Col>
        <Col md={12} xs={24}>
          <Link to={'/producer/news/list'}>
            <Card hoverable className='h-full min-h-37.5'>
              <Typography.Title level={4}>Novidades</Typography.Title>
              <Typography.Text>
                Fique por dentro das principais novidades que estão acontecendo no Orbita e nas outras plataforma da
                Eduzz!
              </Typography.Text>
            </Card>
          </Link>
        </Col>
      </Row>
    </div>
  );
}

export default WithQualificationValidation(QuickStart);
